// Import model
import { Calculation } from '../models/Calculation';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for Calculation - handles JSON serialization and deserialization with type validation
 */
export class CalculationSerializer {
  /**
   * Deserializes a JSON string into a Calculation instance
   */
  static deserialize(json: string): Calculation {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a Calculation instance
   */
  static fromObject(obj: any): Calculation {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to Calculation');
    }


    const instance: Calculation = {
      t: obj['_t'] as string,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of Calculation instances
   */
  static deserializeArray(json: string): Calculation[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a Calculation instance to a JSON string
   */
  static serialize(instance: Calculation): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a Calculation instance to a plain object
   */
  static toObject(instance: Calculation): any {
    return {
      '_t': instance.t,
    };
  }

  /**
   * Serializes an array of Calculation instances to a JSON string
   */
  static serializeArray(instances: Calculation[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
